(() => {
  if (!document.body.classList.contains('template-product')) return;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const initialized = new WeakMap();
  const content = document.getElementById('MainContent');
  if (!content) return;
  const animateTitle = (heading) => {
    const title = heading.textContent.trim();
    if (!title || initialized.get(heading) === title) return;
    initialized.set(heading, title);
    if (heading.hasAttribute('aria-label')) heading.setAttribute('aria-label', title);
    if (reducedMotion.matches) return;
    // Keep a complete accessible heading and reserve the final text's layout.
    heading.setAttribute('aria-label', title);
    const visual = document.createElement('span');
    visual.setAttribute('aria-hidden', 'true');
    let index = 0;
    const count = Array.from(title).length;
    const interval = Math.min(100, 4000 / Math.max(1, count));
    title.split(/(\s+)/).forEach((word) => {
      if (/^\s+$/.test(word)) { visual.append(document.createTextNode(word)); index += word.length; return; }
      const wordSpan = document.createElement('span');
      wordSpan.className = 'sw-title-word';
      Array.from(word).forEach((character) => {
        const letter = document.createElement('span');
        letter.className = 'sw-title-character';
        letter.textContent = character;
        letter.style.setProperty('--sw-character-delay', `${index++ * interval}ms`);
        wordSpan.append(letter);
      });
      visual.append(wordSpan);
    });
    heading.replaceChildren(visual);
  };
  const hasContent = (block) => {
    // Inspect the existing nodes: cloning custom elements invokes Ella's
    // variant constructors and can change the live price/subtotal.
    const meaningful = (node) => {
      if (node.nodeType === Node.TEXT_NODE) return !!node.textContent.trim();
      if (node.nodeType !== Node.ELEMENT_NODE) return false;
      if (node.matches('script, style, template, link, [hidden], input[type="hidden"], .hidden, .visually-hidden')) return false;
      const style = getComputedStyle(node);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
      if (node.matches('img, svg, video, iframe, button, input, select, textarea, [role="button"]')) return true;
      return Array.from(node.childNodes).some(meaningful);
    };
    return Array.from(block.childNodes).some(meaningful);
  };
  const refresh = () => {
    content.querySelectorAll('.productView-product > .productView-moreItem').forEach((block) => {
      const empty = !hasContent(block);
      if (block.classList.contains('sw-product-empty') !== empty) block.classList.toggle('sw-product-empty', empty);
    });
    content.querySelectorAll('h1.productView-title').forEach(animateTitle);
  };
  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; refresh(); });
  };
  refresh();
  // Async review/pickup/app content restores its block when content arrives.
  const observer = new MutationObserver((records) => {
    const meaningful = records.some((record) => {
      if (record.type !== 'attributes' || record.attributeName !== 'class') return true;
      const normalized = (value) => (value || '').split(/\s+/).filter((name) => name && name !== 'sw-product-empty').sort().join(' ');
      return normalized(record.oldValue) !== normalized(record.target.getAttribute('class'));
    });
    if (meaningful) schedule();
  });
  observer.observe(content, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'hidden', 'style'], attributeOldValue: true });
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', schedule);
})();
